// extracted by mini-css-extract-plugin
export var readonly = "_dc-1";
export var star = "_dc-0";